import { Component, input } from '@angular/core';
import { landgLogoDarkUrl, landgLogoUrl } from '@shared/constants/logos';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'lib-footer',
  templateUrl: 'footer.component.html',
  styleUrls: ['footer.component.scss'],
  imports: [SvgIconComponent],
})
export class FooterComponent {
  public readonly showDisclaimer = input.required<boolean>();
  public year = new Date().getFullYear();
  public readonly landgLogoUrl = landgLogoUrl;
  public readonly landgLogoDarkUrl = landgLogoDarkUrl;
}
